import { useSelector, useDispatch } from "react-redux";

const useHistorical = () => {
  const dispatch = useDispatch();
  const { data, pieceSelected, temporalLine } = useSelector(state => state.historical);

  const setPiece = piece => {
    dispatch({ type: "SET_PIECE", piece })
  };

  return { historical: data, pieceSelected, temporalLine, setPiece };
};

export default useHistorical;
